export enum ReasonCodeStatus {
  Submitted,
  Completed,
  Expired,
  Error,
  New
}